module.exports = __webpack_public_path__ + "img/Untitled-1.dbceec68.png";